"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RESULTS_CONTAINERS = exports.CONTAINERS = void 0;
exports.CONTAINERS = {
    RATEQUALITY_SHIPMENTS_AP_TESTING: 'ratequality-shipments-ap-testing',
    RATEQUALITY_SHIPMENTS_BATCH: 'ratequality-shipments-batch',
    RATEQUALITY_SHIPMENTS_CARRIER_RATE_COMPARE: 'ratequality-shipments-carrier-rate-compare',
    RATEQUALITY_SHIPMENTS_PARCEL_RATE: 'ratequality-shipments-parcel-rate',
    RATEQUALITY_SHIPMENTS_GEO_MILEAGE: 'ratequality-shipments-geo-mileage',
    RATEQUALITY_SHIPMENTS_RATING_ANALYSIS: 'ratequality-shipments-rating-analysis',
    RATEQUALITY_SHIPMENTS_RETRIEVAL: 'ratequality-shipments-retrieval',
    AUDITANALYSES_SHIPMENTS_REQUEST: 'auditanalyses-shipments-request',
};
exports.RESULTS_CONTAINERS = {
    RATEQUALITY_SHIPMENTS_AP_TESTING_RESULTS: 'ratequality-shipments-ap-testing-results',
    RATEQUALITY_SHIPMENTS_BATCH_RESULTS: 'ratequality-shipments-batch-results',
    RATEQUALITY_SHIPMENTS_CARRIER_RATE_COMPARE_RESULTS: 'ratequality-shipments-carrier-rate-compare-results',
    RATEQUALITY_SHIPMENTS_PARCEL_RATE_RESULTS: 'ratequality-shipments-parcel-rate-results',
    RATEQUALITY_SHIPMENTS_GEO_MILEAGE_RESULTS: 'ratequality-shipments-geo-mileage-results',
    RATEQUALITY_SHIPMENTS_RATING_ANALYSIS_RESULTS: 'ratequality-shipments-rating-analysis-results',
    RATEQUALITY_SHIPMENTS_RETRIEVAL_RESULTS: 'ratequality-shipments-retrieval-results',
    AUDITANALYSES_SHIPMENTS_RESPONSE: 'auditanalyses-shipments-results',
};
